import { makeObservable } from 'mobx'

import type { IAppConfig } from '~/client/src/shared/Config'
import ApiAuthService from '~/client/src/shared/services/ApiAuthService'
import ProcoreService from '~/client/src/shared/services/ProcoreService'
import StruxHubAuthService from '~/client/src/shared/services/StruxHubAuthService'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import InitialState from '~/client/src/shared/stores/InitialState'
import RootStore from '~/client/src/shared/stores/Root.store'
import GraphExecutor from '~/client/src/shared/utils/GraphExecutor'

import LoginCommonStore from './ui/LoginCommon.store'

export default class LoginRootStore extends RootStore {
  public common: LoginCommonStore

  public constructor(
    configuration: IAppConfig,
    public state: InitialState,
    public eventsStore: EventsStore,
    apiAuthService: ApiAuthService,
    struxHubAuthService: StruxHubAuthService,
    procoreService: ProcoreService,
    graphExecutor: GraphExecutor,
    isTestEnv: boolean,
  ) {
    super(
      state,
      configuration,
      eventsStore,
      LoginCommonStore,
      apiAuthService,
      struxHubAuthService,
      procoreService,
      graphExecutor,
      isTestEnv,
    )

    makeObservable(this)
  }
}
